import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Ajouter — croix dans une pastille duotone */
export const PlusIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <circle cx="12" cy="12" r="9.5" fill="var(--equiply-icon-bg)" fillOpacity="0.45" />
      <circle cx="12" cy="12" r="8.25" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      <path d="M12 8v8M8 12h8" stroke="var(--equiply-icon-fg)" strokeWidth="1.75" strokeLinecap="round" />
    </svg>
  ),
);
PlusIcon.displayName = "PlusIcon";
